import { apiUtils, appConstants } from 'apis/common';
import { Instrument } from 'defs/instrument';

export async function underlyingApi(): Promise<Instrument[]> {
  const resp = await apiUtils.callApi(appConstants.UNDERLYINGS_URL, 'GET', null);
  const data: Instrument[] = resp.data?.payload;
  return data;
}
